import { useContext, useEffect, useRef, useState } from "react";
import "./CheckOutPayment.css";
import CheckOutList from "../CheckOutList/CheckOutList";
import { ReactComponent as Link } from "../../assets/icons/link.svg";
import ButtonPlane from "../../UI/Button/ButtonPlane";
import Button from "../../UI/Button/Button";
import { connect } from "react-redux";
import { setPageCount } from "../../state_management/actions";
import { stateType } from "../../store";
import { handleCopy } from "../../utilities/copyHandler";
import { baseName } from "../../settings";
import { useAsync } from "../../utilities/asyncFunc";
import { reserve } from "../../state_management/epics/order";
import { usePayType } from "./usePayment";
import CheckOutPaymentLeft from "./CheckOutPaymentLeft";
import {
  orderType,
  proceed_val_type
} from "../../state_management/reducers/order";
import { LocaleContext } from "../../AppProvider";
import CheckOutPaymentElements from "./CheckOutPaymentElements";

const largeButtonContainerId = "checkout_large_button_container";
const smallButtonContainerId = "checkout_small_button_container";
const CheckOutPayment = ({
  clientSecret,
  orderId,
  orderSuccess,
  Total,
  orderDetails,
  depositUnavailable,
  usePay,
  error,
  processing,
  disabled
}: {
  clientSecret: string | undefined;
  orderId: number | undefined;
  orderSuccess: boolean;
  orderDetails: orderType;
  Total: number;
  depositUnavailable: boolean;
  usePay: usePayType;
  error: string | undefined;
  processing: boolean;
  disabled: boolean;
}) => {
  const {
    createOrUpdateOrderRes,
    depositValue,
    TotalDeposit,
    processPaymentHooks,
    showContent
  } = usePay;

  const token = createOrUpdateOrderRes?.data?.order.reschedule_token;
  const loading = createOrUpdateOrderRes.loading;

  return (
    <div className="checkOutPayment_wrapper">
      <div className="checkout_form checkout_content_wrapper">
        <div className="checkout_left">
          <div>
            <CheckOutPaymentLeft
              depositUnavailable={depositUnavailable}
              TotalDeposit={TotalDeposit}
              children={
                (clientSecret && showContent() && (
                  <CheckOutPaymentElements
                    returnUrl={`${window.location.origin}${baseName}/checkout?direct=true&id=${orderId}&token=${token}`}
                    clientSecret={clientSecret}
                    error={error}
                    customerDetails={{
                      firstName: orderDetails.client_firstname,
                      lastName: orderDetails.client_lastname,
                      email: orderDetails.client_email,
                      phone: orderDetails.client_mobile,
                      address: orderDetails.client_address
                    }}
                    disabledButton={
                      loading ||
                      disabled ||
                      processing ||
                      orderSuccess ||
                      !clientSecret ||
                      depositValue === undefined
                    }
                    processPaymentHooks={processPaymentHooks}
                    Button={{
                      large: {
                        id: largeButtonContainerId,
                        component: (props) => {
                          return (
                            <PaymentButtons
                              orderId={orderId}
                              link={
                                token && orderId
                                  ? `${window.location.origin}${baseName}/checkout?direct=true&id=${orderId}&token=${token}`
                                  : undefined
                              }
                              {...props}
                            />
                          );
                        }
                      },
                      small: {
                        id: smallButtonContainerId,
                        component: (props) => {
                          return (
                            <PaymentButtons
                              orderId={orderId}
                              link={
                                token && orderId
                                  ? `${window.location.origin}${baseName}/checkout?direct=true&id=${orderId}&token=${token}`
                                  : undefined
                              }
                              smallScreen
                              {...props}
                            />
                          );
                        }
                      }
                    }}
                  />
                )) || <></>
              }
            />
            <SmallButton showDefault={!clientSecret || !showContent()} />{" "}
            {/** These are placeholder buttons */}
          </div>
        </div>
        <div className="checkout_right">
          <CheckOutList
            buttonJSX={
              <LargeButton
                showDefault={!clientSecret || !showContent()}
              /> /** These are placeholder buttons */
            }
          />
        </div>
      </div>
    </div>
  );
};

const SmallButton = ({ showDefault }: { showDefault: boolean }) => {
  return (
    <>
      <div id={smallButtonContainerId}></div>
      {showDefault && (
        <PaymentButtons
          link={undefined}
          disabled={true}
          handler={() => {}}
          smallScreen
        />
      )}
    </>
  );
};

const LargeButton = ({ showDefault }: { showDefault: boolean }) => {
  return (
    <>
      <div id={largeButtonContainerId}></div>
      {showDefault && (
        <PaymentButtons link={undefined} disabled={true} handler={() => {}} />
      )}
    </>
  );
};

const mapStateToProps = (state: stateType) => ({
  pageCount: state.commonReducer.pageCount,
  orderDirect: state.orderReducer.direct,
  orderDetails: state.orderReducer.details,
  orderSuccess: state.orderReducer.success
});

const mapDispatchToProps = (dispatch: any) => ({
  setPageCount: (data: number) => {
    dispatch(setPageCount(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckOutPayment);

const PaymentButtons = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ({
    pageCount,
    setPageCount,
    smallScreen,
    link,
    disabled,
    orderSuccess,
    orderDirect,
    orderId,
    handler
  }: {
    pageCount: proceed_val_type;
    setPageCount: (data: number) => void;
    smallScreen?: boolean;
    disabled?: boolean;
    link: string | undefined;
    orderSuccess: boolean;
    orderDirect: boolean;
    orderId?: number;
    handler: () => void;
  }) => {
    const { t } = useContext(LocaleContext);
    const deactivateBars = orderSuccess || orderDirect;
    const mountedRef = useRef(true);
    useEffect(() => {
      return () => {
        mountedRef.current = false;
      };
    }, []);

    const [timeoutId, setTimeoutId] = useState<number>();
    const [copied, setCopied] = useState(false);

    const reserveBooking = useAsync(
      {
        asyncFunc: reserve,
        funcParams: { id: orderId },
        immediate: false
      },
      []
    );

    return (
      <div className={`${smallScreen ? `showSm` : ``}`}>
        <div
          className={`check_list_btn_wrapper ${deactivateBars ? `direct` : ``}`}
        >
          {deactivateBars ? (
            ``
          ) : (
            <div className="check_list_btn_inner flex">
              <ButtonPlane
                onClick={() => setPageCount(pageCount - 1)}
                size="sm"
                span
              >
                {t("Back")}
              </ButtonPlane>
            </div>
          )}
          <div className="check_list_btn_inner flex">
            <Button onClick={handler} disabled={disabled} size="sm" span>
              {t("Pay")}
            </Button>
          </div>
        </div>
        {deactivateBars || !link ? (
          ``
        ) : (
          <div
            onClick={() => {
              handleCopy(`${link}`, () => {
                if (timeoutId) {
                  clearTimeout(timeoutId);
                }
                reserveBooking.execute({ id: orderId });
                setCopied(true);
                const copyTimeout = window.setTimeout(() => {
                  if (mountedRef.current) {
                    setCopied(false);
                  }
                }, 3000);
                setTimeoutId(copyTimeout);
              });
            }}
            className="copy_link_wrapper"
          >
            <div className="copy_link_icon">
              <Link className="img_div_contain" />
            </div>
            <div className="copy_link_container flex1">
              <span className="fontBlue">
                {t("Copy my cart link for someone else to pay")}
              </span>
              <div className={`copyNotif ${!copied ? `hideNotif` : ``}`}>
                {t("Copied")}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
);
